// Fase 31.6.5: shared palette for per-user accent color (team_members.member_color).
// Backend mirror lives in pocketbase/hooks/member-color.js — keep both in sync.
// No yellow/warning hue per project rule (feedback_no_warning_yellow).

export type PaletteEntry = {
  readonly id: string;
  readonly value: string;
  readonly label: string;
};

export const MEMBER_COLOR_PALETTE: readonly PaletteEntry[] = [
  { id: 'red', value: '#ff4444', label: 'Rojo' },
  { id: 'coral', value: '#ff7777', label: 'Coral' },
  { id: 'crimson', value: '#fe5e5e', label: 'Carmesí' },
  { id: 'mint', value: '#5efea8', label: 'Menta' },
  { id: 'teal', value: '#42d4d4', label: 'Turquesa' },
  { id: 'blue', value: '#017efa', label: 'Azul' },
  { id: 'violet', value: '#9c7afa', label: 'Violeta' },
  { id: 'magenta', value: '#fa7ad4', label: 'Magenta' },
] as const;

const PALETTE_VALUES: readonly string[] = MEMBER_COLOR_PALETTE.map(
  (p) => p.value
);

export function isPaletteColor(value: string): boolean {
  if (!value) return false;
  return PALETTE_VALUES.includes(value);
}

// djb2 hash → deterministic pick. Used to mirror the server's auto-assign
// so previewing the auto color (before it lands in DB) shows the same hue.
export function pickAutoMemberColor(seed: string): string {
  const s = String(seed || '');
  if (!s) return PALETTE_VALUES[0] ?? '#ff4444';
  let hash = 5381;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 33 + s.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % PALETTE_VALUES.length;
  return PALETTE_VALUES[idx] ?? '#ff4444';
}
